// extracted by css-extract-rspack-plugin
export default {"container":"ProcedureNew__container--JpN9f","cardSubText":"ProcedureNew__cardSubText--rPgIO"};